import React from "react";
import { heroImages } from "../data/mock";
import { PageHero, SectionTitle, Reveal, CTASection } from "../components/common";
import WeatherWidget from "../components/WeatherWidget";
import TideTracker from "../components/TideTracker";
import Partners from "../components/Partners";
import { Sun, Waves, Wind, Fish } from "lucide-react";

const Weather = () => (
  <>
    <PageHero image={heroImages[2].img} eyebrow="Marine Forecast" title="San Juan del Sur Fishing Weather" sub="Live 7-day marine conditions for the Pacific coast — swell, wind and temperature. We highlight the best day to be on the water." />
    <section className="py-14">
      <div className="container-x">
        <Reveal><WeatherWidget /></Reveal>
        <div className="mt-6"><Reveal><TideTracker /></Reveal></div>
        <div className="grid sm:grid-cols-3 gap-4 mt-8">
          {[[Waves,"Read the swell","Calmer seas (lower wave height) mean a smoother ride and easier bait presentation — ideal for offshore runs."],[Wind,"Mind the wind","Light morning winds are best. We often run early to beat the afternoon breeze on the Pacific."],[Fish,"Match the season","Pair the forecast with our fishing calendar to line up conditions with your target species."]].map(([Icon,t,d])=>(
            <div key={t} className="rounded-2xl border border-white/10 bg-[#0e2740] p-6"><Icon className="h-7 w-7 text-[#f5a524]" /><h3 className="font-heading text-lg text-white mt-3">{t}</h3><p className="text-sm text-slate-400 mt-1">{d}</p></div>
          ))}
        </div>
      </div>
    </section>
    <Partners />
    <CTASection image={heroImages[1].img} />
  </>
);

export default Weather;
